import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';
dayjs.extend(tz);
dayjs.extend(utc);

@Pipe({
    name: 'utcToPacificTime',
    standalone: true
})
export class UtcToPacificTimePipe implements PipeTransform {
    //with the time zone from 'America/Los_Angeles' will automatically convert to PDT or PST
    private readonly _pstTimeZone = 'America/Los_Angeles';
    transform(utcDate: Date, format: string): string {
        return dayjs.utc(utcDate).tz(this._pstTimeZone).format(format);
    }
}
